import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DefineBootboxId } from 'app/resources/classes/index';
import { Rotas } from 'app/resources/classes/rotas';
import { Subject } from 'app/resources/classes/subject';
import { CartaoService } from 'app/resources/services/cartao.service';
import { CiService } from 'app/resources/services/ci.service';
import { HttpService } from 'app/resources/services/http.service';
import { PermissionService } from 'app/resources/services/permission.service';
import { SaldoService } from 'app/resources/services/saldo.service';
import { SessionService } from 'app/resources/services/session-service.service';
import 'bootbox';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import { PoliticaTermoBi } from '../bi/PoliticaTermo.bi';
import { PoliticaTermoService } from './politica-termo.service';

declare var $: any;

@Injectable()
export class LoginService {
  logotipo: string;
  clienteMensagem: any;

  private router: Router;
  private processando: boolean;
  public subject: Subject;
  private numeroCartao = '';
  public clienteObservacao: string;
  private location: LocationStrategy;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  constructor(
    router: Router,
    location: LocationStrategy,
    public sessionService: SessionService,
    public cartaoService: CartaoService,
    public http: HttpService,
    public ciService: CiService,
    public permissionService: PermissionService,
    public saldoService: SaldoService,
    private politicaTermoService: PoliticaTermoService,
    public sanitizer: DomSanitizer) {
    this.router = router;
    this.location = location;
  }

  public doLogin(subject: Subject): Observable<Response> {
    this.numeroCartao = subject.principal;
    this.subject = subject;
    this.processando = true;
    let senhaNula = true;

    for (let i = 0; i < this.subject.password.length; i++) {
      if (this.subject.password.charAt(i) !== ' ') {
        senhaNula = false;
        break;
      }
    } if (senhaNula) {
      this.bootboxAlertComId.alerta('Atenção! Usuario ou Senha nula!');
      this.processando = false;
      return new Observable<any>((observer) => {
        observer.next(false);
      });
    } else {
      return new Observable<Response>((observer) => {
        this.http.pathV2().put('login',
          { 'principal': subject.principal, 'password': subject.password })
          .subscribe(
            sucesso => {
              this.sessionService.setSession(sucesso.json());
              this.subject = new Subject();
              this.processando = false;
              this.cartaoService.setCartao(sucesso.json().cartao);
              this.loadSession();
              this.permissionService.onPermissionsChanged().subscribe(() => this.goHome());
              observer.next(null);
              new PoliticaTermoBi.Rest(this.http).acceptanceCheck(this.sessionService.getUserUuid(), this.sessionService.getUserId())
                .subscribe(
                  successPolicesTerms => {
                    this.politicaTermoService.setResponseTermoUso(PoliticaTermoBi.Parser.fill(successPolicesTerms.json()));
                  }, errorPolicesTerms => {
                    observer.error(errorPolicesTerms);
                  }
                )
            }, erro => {
              if (this.subject !== undefined) {
                this.subject.password = undefined;
              }
              observer.error(erro);
              this.processando = false;
            }
          );
      });
    }

  }
  public goHome() {
    if (this.isVoucher()) {
      this.router.navigate([Rotas.VOUCHER_CONFIRMAR]);
      // this.router.navigateByUrl('/voucher');
    } else {
      this.ciService.atualizarNaoLidas();
      this.ciService.atualizarAvisosCI();
      this.router.navigate(['/home']);
      $('#myModal').modal('hide');
    }
  }

  public isVoucher() {
    return this.numeroCartao.length === 35 && !this.numeroCartao.includes('@');
  }

  public changeRoute(route?: string) {
    if (this.politicaTermoService.isAcceptedPoliciesAndTerms()) {
      this.ciService.atualizarNaoLidas();
      this.ciService.atualizarAvisosCI();
      this.router.navigate([route]);
      $('#myModal').modal('hide');
    } else {
      $('#myModalPolicesTerms').modal('show');
    }
  }

  public loadSession() {
    this.permissionService.fillPermissions();
    this.getObservacao();
    this.cartaoService.revalidar();
    this.saldoService.initialize();
  }

  public getObservacao() {
    if (this.sessionService.getClientUuid()) {
      this.http.pathRest().get('clientes/'
        + this.sessionService.getClientUuid() + '/observacao/', true)
        .subscribe(
          sucesso => {
            this.clienteObservacao = sucesso.text().substr(1, sucesso.text().length - 2);
          });
    }
  }

  public getPathLogo() {
    let parametro = undefined;
    const location = (<any>this.location)._platformLocation.location.href;
    if (location === 'www.picpontos.com.br' || location === 'picpontos.com.br'
      || location === 'homolog.picpontos.com.br') {
      if (this.sessionService !== undefined && this.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.sessionService.getClientUuid();
      } else {
        parametro = '?type=context&content=' + (<any>this.location)._platformLocation.location.href.split('/')[3];
      }
    } else {
      if (this.sessionService !== undefined && this.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.sessionService.getClientUuid();
      } else {
        parametro = '?type=domain&content=' + location;
      }
    }
    return this.http.pathApi().path + 'clientes/logotipo/' + parametro;
  }

  public doLogout() {
    const that = this;

    const confirmLogout = bootbox.confirm({
      message: 'Deseja encerrar a sessão?',
      buttons: {
        confirm: {
          label: 'Sim',
          className: 'app-btn-best'
        },
        cancel: {
          label: 'Não',
          className: 'btn-default'
        }
      }, callback: function (result) {
        if (result) {

          that.http.pathV2().get('auth/logout', true)
            .subscribe(
              sucesso => {
                that.permissionService.clean();
                that.sessionService.invalidaSessao();
                // const location: Location = (<any>that.location)._platformLocation.location.href;
                that.router.navigateByUrl('');
              },
              erro => {
                this.bootboxAlertComId.alerta(erro._body);
              });
        }
      }
    });

    confirmLogout.on('shown.bs.modal', function () {
      $('button[data-bb-handler="cancel"]').attr('id', 'btn-bootbox-cancel');
      $('button[data-bb-handler="confirm"]').attr('id', 'btn-bootbox-confirm');
      $('button[class="bootbox-close-button close"]').attr('id', 'btn-bootbox-close');
      $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
    });

  }

  public getMsgInicial(): Observable<Response> {
    const location = (<any>this.location)._platformLocation.location;
    let parametro = undefined;
    if (location.hostname === 'www.picpontos.com.br' ||
      location.hostname === 'picpontos.com.br' ||
      location.hostname === 'homolog.picpontos.com.br') {

      parametro = '?type=context&content=' + (<any>this.location)._platformLocation.location.href.split('/')[3];

    } else {
      parametro = '?type=domain&content=' + location.hostname;
    }

    return this.http.pathApi().get('clientes/mensagem/' + parametro);

  }

  public possuiCadastroUsuario(): Observable<Response> {
    const location = (<any>this.location)._platformLocation.location;
    let enderecoAcesso = (<any>this.location)._platformLocation.location.href.split('/')[3];
    let type: string;
    if (enderecoAcesso === undefined || enderecoAcesso === '#') {
      enderecoAcesso = location.hostname;
      type = 'domain';
    } else {
      type = 'context';
    }
    return this.http.pathV2().get('api/clientes/cliente/cadastro?type=' + type + '&' + 'content=' + enderecoAcesso);
  }

  public getLogo() {
    let parametro = undefined;
    const location = (<any>this.location)._platformLocation.location;
    if (location.hostname === 'www.picpontos.com.br' ||
      location.hostname === 'picpontos.com.br' ||
      location.hostname === 'homolog.picpontos.com.br') {
      if (this.sessionService !== undefined && this.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.sessionService.getClientUuid();
      } else {
        parametro = '?type=context&content=' + (<any>this.location)._platformLocation.location.href.split('/')[3];
      }
    } else {
      if (this.sessionService !== undefined && this.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.sessionService.getClientUuid();
      } else {
        parametro = '?type=domain&content=' + location.hostname;
      }
    }
    return 'clientes/logotipo/' + parametro;
  }

  public geraLogo(): Observable<Response> {
    return this.http.pathApi().get(this.getLogo());
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/login.service.ts